/* globals document, window */
import Slider from './components/slider';
import VideoBg from './components/video';
import Header from './components/header';
import Search from './components/search';
import ExpandCollapse from './components/expandCollapse';
import Hamburger from './components/hamburger';

const $ = require('jquery');

$(document).ready(() => {
  Slider.init();
  VideoBg.init();
  Header.init();
  Search.init();
  ExpandCollapse.init();
  Hamburger.init();
  $(window).resize(() => {
    VideoBg.onResize();
  });
});
